<div class="layout-wrapper" [class.sidebar-collapsed]="sidebarCollapsed">

    <app-sidebar [collapsed]="sidebarCollapsed" [mobileOpen]="mobileMenuOpen" (closeMenu)="closeMobileMenu()"
        (toggleCollapse)="toggleSidebar()">
    </app-sidebar>

    <div class="main-wrapper">

        <app-header (toggleMobileMenu)="toggleMobileMenu()" (changePassword)="openChangePassword()">
        </app-header>

        <div class="page-content">
            <router-outlet></router-outlet>
        </div>

    </div>

    <app-change-password
        *ngIf="showChangePasswordModal"
        [navigateBackOnSuccess]="false"
        [optional]="changePasswordByChoice"
        (cancelled)="closeChangePassword()"
        (passwordChanged)="onPasswordChanged()">
    </app-change-password>
</div>


